import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FooterPortalService {
  private footerPortalSubject = new BehaviorSubject<TemplateRef<any> | null>(null);
  public footerPortal$: Observable<TemplateRef<any> | null> = this.footerPortalSubject.asObservable();

  setFooterPortal(portal: TemplateRef<any> | null): void {
    Promise.resolve().then(() => this.footerPortalSubject.next(portal));
  }

  clearAll(): void {
    Promise.resolve().then(() => this.footerPortalSubject.next(null));
  }
}
